"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.divider = void 0;
var divider = exports.divider = {
  keyCommand: 'divider'
};